module.exports = __webpack_public_path__ + "img/slide-14-5.58d3c2fb.jpg";